import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import './Hero.css';

const Hero = () => {
  const [contentRef, contentVisible] = useScrollAnimation();
  const [imageRef, imageVisible] = useScrollAnimation({ threshold: 0.2 });

  const handleBookingClick = () => {
    window.open(
      "https://calendly.com/bsquarefinancial-info/1-on-1-bsquare-15-minute-cash-flow-audit",
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <section id="home" className="hero">
      <div className="hero-container">
        <div 
          ref={contentRef}
          className={`hero-content ${contentVisible ? 'animate-in' : ''}`}
        >
          <h1 className="hero-headline">
            Financial Protection Strategies for Professionals, Entrepreneurs, and Homeowners
          </h1>
          <p className="hero-subheadline">
            Structured insurance and protection planning designed to safeguard income, reduce risk, and support long-term financial confidence.
          </p>
          <div className="hero-cta-wrapper">
            <button className="hero-cta-button" onClick={handleBookingClick}>
              Book a Confidential Consultation
              <span className="arrow-icon">→</span>
            </button>
            <p className="hero-cta-micro">No obligation. No product pressure.</p>
          </div>
        </div>
        <div 
          ref={imageRef}
          className={`hero-image-container ${imageVisible ? 'animate-in' : ''}`}
        >
          <img 
            src="https://images.unsplash.com/photo-1511895426328-dc8714191300?w=800&h=600&fit=crop" 
            alt="Happy family" 
            className="hero-image"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
